import gql from 'graphql-tag';

export default gql`
  fragment notificationFragment on Notification {
    id
    status
    statusText
    message
    startDate
    endDate
    startDateText
    endDateText
  }
`;
